(() => {
  const desktop = window.matchMedia('(min-width: 1000px)');
  let frame;

  function alignMegaMenus() {
    const items = document.querySelectorAll('.header__primary-nav-item');

    items.forEach((item) => {
      const megaMenu = item.querySelector('.mega-menu');

      if (!megaMenu) return;

      megaMenu.style.removeProperty('--wt-mega-menu-start');

      if (!desktop.matches) return;

      const itemRect = item.getBoundingClientRect();
      const megaRect = megaMenu.getBoundingClientRect();

      /*
       * Align the left edge of the mega-menu content
       * with the left edge of the header menu item.
       *
       * If the menu is temporarily hidden and therefore
       * has no measurable position, Prestige's mega menu
       * is viewport based, so itemRect.left is used.
       */
      const menuLeft = megaRect.width > 0 ? megaRect.left : 0;
      const offset = Math.max(0, itemRect.left - menuLeft);

      megaMenu.style.setProperty(
        '--wt-mega-menu-start',
        `${offset}px`
      );
    });

    if (desktop.matches) {
      document.documentElement.classList.add('wt-mega-aligned');
    } else {
      document.documentElement.classList.remove('wt-mega-aligned');
    }
  }

  function scheduleAlignment() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(alignMegaMenus);
  }

  document.addEventListener('DOMContentLoaded', scheduleAlignment);
  window.addEventListener('load', scheduleAlignment);
  window.addEventListener('resize', scheduleAlignment);

  /* Recalculate inside the Shopify theme editor */
  document.addEventListener('shopify:section:load', scheduleAlignment);
  document.addEventListener('shopify:section:reorder', scheduleAlignment);

  /* Recalculate just before/opening a mega menu */
  document.addEventListener('pointerover', (event) => {
    const item = event.target.closest('.header__primary-nav-item');

    if (item && item.querySelector('.mega-menu')) {
      scheduleAlignment();
    }
  });

  document.addEventListener('focusin', (event) => {
    const item = event.target.closest('.header__primary-nav-item');

    if (item && item.querySelector('.mega-menu')) {
      scheduleAlignment();
    }
  });
})();